<template>
  <v-container class="pa-1" fluid>
    <v-form ref="form">
      <v-row>
        <v-col cols="12">
          <v-card :key="index" style="margin-bottom: 15px;" v-for="(country, index) in delegation.country">
            <v-card-title class="grey lighten-5 py-2">
              <h5>{{ $t("delegation.form.countryFragment") }} {{ index + 1 }}</h5>
              <v-spacer />
              <v-tooltip top>
                {{ $t("delegation.form.removeThisCountryFragment") }}
                <template #activator="{on}">
                  <v-btn :disabled="$store.getters['Ajax/loading'] || $store.state.Delegation.readonly === true" icon v-on="on" @click="removeCountry(country)">
                    <v-icon>close</v-icon>
                  </v-btn>
                </template>
              </v-tooltip>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col md="4" sm="6" cols="12">
                  <v-row dense class="flex-nowrap">
                    <v-col class="py-0">
                      <country-select
                        :validationMessage="delegationErrors.country[index].country_code"
                        :model.sync="country.country_code"
                        :readonly="$store.state.Delegation.readonly === true"
                        @change="country.region === ''"
                      />
                    </v-col>
                    <v-col v-show="getRegions(country).length > 1" class="py-0">
                      <v-autocomplete
                        :error-messages="delegationErrors.country[index].region"
                        :items="getRegions(country)"
                        :label="$t('delegation.form.fields.country.region.name')"
                        v-model="country.region"
                        :readonly="$store.state.Delegation.readonly === true"
                      />
                    </v-col>
                  </v-row>
                </v-col>
                <v-col md="2" sm="6" cols="12">
                  <v-row style="margin-top: 0" class="flex-nowrap" no-gutters>
                    <v-text-field
                      :error-messages="delegationErrors.country[index].delegation_rate"
                      :label="$t('delegation.form.fields.country.rate.name')"
                      :suffix="country.country_code == null ? '' : country.currency"
                      disabled
                      v-model="country.delegation_rate"
                      :readonly="$store.state.Delegation.readonly === true"
                    />
                    <v-tooltip top v-if="country.delegation_rate !== null && $store.state.Delegation.readonly !== true">
                      <template #activator="{ on }">
                        <v-btn
                          v-on="on"
                          icon
                          style="top: 10px"
                          @click="parseInt(country.delegation_rate) === 0 ? (country.delegation_rate = null) : (country.delegation_rate = '0.00')"
                        >
                          <v-icon>fa-funnel-dollar</v-icon>
                        </v-btn>
                      </template>
                      <span v-if="parseInt(country.delegation_rate) > 0">{{ $t("delegation.form.doNotCalculatePerDiem") }}</span>
                      <span v-if="parseInt(country.delegation_rate) === 0">{{ $t("delegation.form.restorePerDiemRate") }}</span>
                    </v-tooltip>
                  </v-row>
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <date-time-picker-computed
                    :date-time-validation="delegationErrors.country[index].in_date"
                    :dateTimeModel.sync="country.in_date"
                    :default-button="true"
                    :default-value="startDateDefaultValueCountry(country)"
                    :label="$t('delegation.form.fields.country.inDate.name')"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
                <v-col md="3" sm="6" cols="12">
                  <date-time-picker-computed
                    :date-time-validation="delegationErrors.country[index].out_date"
                    :dateTimeModel.sync="country.out_date"
                    :default-button="true"
                    :default-value="endDateDefaultValueCountry(country)"
                    :label="$t('delegation.form.fields.country.outDate.name')"
                    :readonly="$store.state.Delegation.readonly === true"
                  />
                </v-col>
              </v-row>
            </v-card-text>
            <v-expansion-panels v-model="expandedCountryArray[index]">
              <v-expansion-panel
                @change="
                  () => {
                    expandedAccommodation(country, expandedCountryArray[index]);
                  }
                "
              >
                <v-expansion-panel-header class="grey lighten-5">
                  <span>
                    <strong>{{ $t("delegation.form.accommodation") }}: </strong>
                    <span>
                      <b class="green--text">{{ accommodationTotalDays(country) }}</b>
                    </span>
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-row :key="indexAccommodation" v-for="(accommodation, indexAccommodation) in country.accommodation">
                    <v-row class="flex-nowrap px-2 pr-12">
                      <v-col cols="12">
                        <v-row dense>
                          <v-col
                            v-bind:class="[
                              {
                                'xs12 sm6 md4': accommodation.settlement_type_id != null
                              },
                              {
                                'xs12 sm12 md12': accommodation.settlement_type_id == null
                              }
                            ]"
                          >
                            <v-select
                              :error-messages="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].settlement_type_id
                                  : []
                              "
                              :items="accommodationSettlementTypes"
                              :label="$t('delegation.form.fields.accommodation.settlementType.name')"
                              item-text="text"
                              item-value="value"
                              v-model="accommodation.settlement_type_id"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col md="8" sm="6" v-if="accommodation.settlement_type_id === 6" cols="12">
                            <v-text-field
                              :error-messages="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].comment
                                  : []
                              "
                              :readonly="$store.state.Delegation.readonly === true"
                              v-model="accommodation.comment"
                              :label="$t('global.comment')"
                            />
                          </v-col>

                          <v-col
                            md="2"
                            sm="2"
                            v-if="accommodation.settlement_type_id === 2 || accommodation.settlement_type_id === 3 || accommodation.settlement_type_id === 5"
                            cols="12"
                          >
                            <currency-select
                              :model.sync="accommodation.currency"
                              :validation-message="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].currency
                                  : []
                              "
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col
                            md="1"
                            sm="4"
                            v-if="accommodation.settlement_type_id === 2 || accommodation.settlement_type_id === 3 || accommodation.settlement_type_id === 5"
                            cols="12"
                          >
                            <AmountInput
                              :error-messages="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].amount_in_currency
                                  : []
                              "
                              :model.sync="accommodation.amount_in_currency"
                              :over-limit="overLimit(index, indexAccommodation)"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col
                            md="2"
                            sm="6"
                            v-if="accommodation.settlement_type_id === 2 || accommodation.settlement_type_id === 3 || accommodation.settlement_type_id === 5"
                            cols="12"
                          >
                            <date-picker
                              :date-validation="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].invoice_date
                                  : []
                              "
                              :label="$t('delegation.form.fields.accommodation.invoiceDate.name')"
                              :model.sync="accommodation.invoice_date"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col
                            md="3"
                            sm="6"
                            v-if="accommodation.settlement_type_id === 2 || accommodation.settlement_type_id === 3 || accommodation.settlement_type_id === 5"
                            cols="12"
                          >
                            <ajax-single-file
                              :accept="$store.getters['Delegation/allowedAttachmentFileFormat']"
                              :items="fileProperties(accommodation.file_id)"
                              :model.sync="accommodation.file_id"
                              :validation-message="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].file_id
                                  : []
                              "
                              v-on:fileRemoved="removeFileFromDelegationFiles"
                              v-on:fileUploaded="addFileToDelegationFiles"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col class="align-center d-flex" v-if="accommodation.settlement_type_id === 4">
                            {{ $t("delegation.form.lumpSumWillBeCalculatedAutomatically") }}
                          </v-col>
                          <v-col v-if="accommodation.settlement_type_id === 1">
                            <ajax-booking-hotel-select
                              :bookingText.sync="accommodation.booking_text"
                              :fileId.sync="accommodation.file_id"
                              :model.sync="accommodation.booking_id"
                              :validation-message="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].booking_id
                                  : []
                              "
                              v-on:fileRemoved="removeFileFromDelegationFiles"
                              v-on:fileUploaded="addFileToDelegationFiles"
                              v-on:importAccommodationData="bookingData => importAccommodationData(bookingData, accommodation)"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                        </v-row>
                        <v-row dense>
                          <v-col md="2" sm="4" cols="12">
                            <v-text-field :label="$t('delegation.form.fields.country.breakfastCount.name')" disabled v-bind:value="0" />
                          </v-col>
                          <v-col md="2" sm="4" cols="12">
                            <v-text-field :label="$t('delegation.form.fields.country.lunchCount.name')" disabled v-bind:value="0" />
                          </v-col>
                          <v-col md="2" sm="4" cols="12">
                            <v-text-field :label="$t('delegation.form.fields.country.dinnerCount.name')" disabled v-bind:value="0" />
                          </v-col>
                          <v-col md="3" sm="6" cols="12">
                            <date-picker
                              :date-validation="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].start_date
                                  : []
                              "
                              :default-button="true"
                              :default-value="startDateDefaultValueAccommodation(index, indexAccommodation)"
                              :label="$t('delegation.form.fields.accommodation.startDate.name')"
                              :model.sync="accommodation.start_date"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                          <v-col md="3" sm="6" cols="12">
                            <date-picker
                              :date-validation="
                                typeof delegationErrors.country[index].accommodation[indexAccommodation] !== 'undefined'
                                  ? delegationErrors.country[index].accommodation[indexAccommodation].end_date
                                  : []
                              "
                              :default-button="true"
                              :default-value="endDateDefaultValueAccommodation(index, indexAccommodation)"
                              :label="$t('delegation.form.fields.accommodation.endDate.name')"
                              :model.sync="accommodation.end_date"
                              :readonly="$store.state.Delegation.readonly === true"
                            />
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-spacer />
                      <v-col class="align-center d-flex justify-center pa-0">
                        <v-tooltip class="hidden-sm-and-down" top v-if="$store.state.Delegation.readonly !== true">
                          {{ $t("delegation.form.removeAccommodation") }}
                          <template #activator="{on}">
                            <v-btn v-on="on" icon @click="removeAccommodation(country, accommodation)">
                              <v-icon>close</v-icon>
                            </v-btn>
                          </template>
                        </v-tooltip>
                      </v-col>
                    </v-row>
                    <v-btn class="hidden-md-and-up" v-on:click="removeAccommodation(country, accommodation)" v-if="$store.state.Delegation.readonly !== true">
                      {{ $t("delegation.form.removeAccommodation") }}
                    </v-btn>
                    <v-divider v-if="country.accommodation.indexOf(accommodation) !== country.accommodation.length - 1" />
                  </v-row>
                  <v-btn v-on:click="addAccommodation(country)" v-if="$store.state.Delegation.readonly !== true" class="mt-4">
                    {{ $t("delegation.form.addAccommodation") }}
                  </v-btn>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
            <v-expansion-panels :value="0" flat>
              <v-expansion-panel class="grey lighten-3">
                <v-expansion-panel-header>
                  <span>
                    <strong>{{ $t("global.summary") }} </strong>
                    <span
                      ><b class="green--text">{{ calculatedSummary(country, index) }}</b></span
                    >
                  </span>
                </v-expansion-panel-header>
                <v-expansion-panel-content class="grey lighten-5 pb-0">
                  <v-row>
                    <v-col md="2" sm="4" cols="12">
                      <v-text-field
                        :error-messages="delegationErrors.country[index].breakfast_count"
                        :label="$t('delegation.form.fields.country.breakfastCount.name')"
                        placeholder="0"
                        v-model="country.breakfast_count"
                        :readonly="$store.state.Delegation.readonly === true"
                      />
                    </v-col>
                    <v-col md="2" sm="4" cols="12">
                      <v-text-field
                        :error-messages="delegationErrors.country[index].lunch_count"
                        :label="$t('delegation.form.fields.country.lunchCount.name')"
                        placeholder="0"
                        v-model="country.lunch_count"
                        :readonly="$store.state.Delegation.readonly === true"
                      />
                    </v-col>
                    <v-col md="2" sm="4" cols="12">
                      <v-text-field
                        :error-messages="delegationErrors.country[index].dinner_count"
                        :label="$t('delegation.form.fields.country.dinnerCount.name')"
                        placeholder="0"
                        v-model="country.dinner_count"
                        :readonly="$store.state.Delegation.readonly === true"
                      />
                    </v-col>
                    <v-spacer />
                    <v-col md="6" sm="12" cols="12">
                      <v-text-field
                        :readonly="$store.state.Delegation.readonly === true"
                        :label="$t('delegation.form.diet')"
                        :placeholder="calculatedSummary(country, index).replace($t('delegation.form.diet') + ': ', '')"
                        disabled
                      />
                    </v-col>
                  </v-row>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-col>

        <v-col cols="12" v-if="$store.state.Delegation.readonly !== true">
          <v-btn color="accent" v-on:click="addCountry">{{ $t("global.add") }}</v-btn>
        </v-col>
      </v-row>
    </v-form>
  </v-container>
</template>

<script>
import DateTimePickerComputed from "../../CustomInputComponents/DateTimePickerComputed.vue";
import DatePicker from "../../CustomInputComponents/DatePicker.vue";
import AjaxSingleFile from "../../CustomInputComponents/AjaxSingleFile.vue";
import AccommodationSettlementTypes from "../../../staticData/AccommodationSettlementTypes";
import CurrencySelect from "../../CustomInputComponents/CurrencySelect.vue";
import createErrorArray from "../../../repository/errorObjectArray";
import AjaxBookingHotelSelect from "../../CustomInputComponents/AjaxBookingHotelSelect.vue";
import AmountInput from "../../CustomInputComponents/AmountInput.vue";
import CountrySelect from "../../CustomInputComponents/CountrySelect";

export default {
  name: "Country",
  components: {
    CountrySelect,
    AjaxBookingHotelSelect,
    CurrencySelect,
    AjaxSingleFile,
    DateTimePickerComputed,
    DatePicker,
    AmountInput
  },
  props: {
    delegation: {
      type: Object,
      required: true
    },
    delegationErrors: {
      type: Object,
      required: false,
      default: function() {
        return createErrorArray(this.delegation);
      }
    }
  },
  data: () => ({
    countryCodes: [],
    formControls: {
      additionalCostsShow: false
    },
    expandedCountryArray: []
  }),
  watch: {
    delegated(value) {
      this.getCountry(value);
    }
  },
  computed: {
    delegated() {
      return this.delegation.user_id;
    },
    accommodationSettlementTypes: AccommodationSettlementTypes
  },
  methods: {
    fileProperties(fileId) {
      let temp = this.$store.getters["Delegation/delegationEdited"].file.find(function(element) {
        return element.id === fileId;
      });
      if (typeof temp !== "undefined") {
        return [temp];
      }
      return [];
    },
    accommodationTotalDays(item) {
      let countDays = 0;
      for (let accommodation of item.accommodation) {
        let tempStartDate = new Date(accommodation.start_date);
        let tempEndDate = new Date(accommodation.end_date);
        countDays += isNaN(Math.round((tempEndDate - tempStartDate) / (1000 * 60 * 60 * 24)))
          ? 0
          : Math.round((tempEndDate - tempStartDate) / (1000 * 60 * 60 * 24));
      }
      return countDays + " " + this.$t("delegation.form.days");
    },
    removeCountry(item) {
      this.$store.dispatch("Delegation/removeCountry", item);
    },
    addCountry() {
      this.$store.dispatch("Delegation/addCountry");
    },
    addAccommodation(country) {
      if (this.$store.state.Delegation.readonly !== true) this.$store.dispatch("Delegation/addAccommodationToCountry", country);
    },
    removeAccommodation(country, accommodation) {
      this.$store.dispatch("Delegation/removeAccommodationFromCountry", {
        country: country,
        accommodation: accommodation
      });
    },
    calculatedSummary(country, index) {
      let calculation = this.$store.getters["Delegation/delegationCalculation"];
      if (calculation != null && typeof calculation.singleCountryCost !== "undefined" && typeof calculation.singleCountryCost[index] !== "undefined") {
        if (calculation.singleCountryCost[index].currency === "PLN") {
          return this.$t("delegation.form.diet") + ": " + calculation.singleCountryCost[index].amount + " PLN";
        }
        return (
          this.$t("delegation.form.diet") +
          ": " +
          calculation.singleCountryCost[index].amount_in_currency +
          " " +
          calculation.singleCountryCost[index].currency +
          " (~ " +
          calculation.singleCountryCost[index].amount +
          " PLN)"
        );
      }
      return this.$t("delegation.form.fillMissingDataToGetResult");
    },
    overLimit(countryIndex, accommodationIndex) {
      let calculation = this.$store.getters["Delegation/delegationCalculation"];
      if (
        calculation != null &&
        typeof calculation.isValidHotelLimit !== "undefined" &&
        typeof calculation.isValidHotelLimit[countryIndex] !== "undefined" &&
        typeof calculation.isValidHotelLimit[countryIndex][accommodationIndex] !== "undefined"
      ) {
        return !calculation.isValidHotelLimit[countryIndex][accommodationIndex];
      }
      return false;
    },
    getCountry(user_id) {
      let context = this;
      this.axios.get("delegation/get-country?userId=" + user_id).then(function(response) {
        context.countryCodes = [];
        for (let prop in response.data) {
          context.countryCodes.push({
            symbol: response.data[prop].country_symbol,
            name: response.data[prop].polish_name,
            currency: response.data[prop].currency,
            delegationRate: response.data[prop].amount,
            region: response.data[prop].region
          });
        }
        for (let country of context.delegation.country) {
          let countryCodes = context.countryCodes.filter(v => v.symbol === country.country_code);
          if (countryCodes.length === 0) {
            country.region = null;
            country.country_code = null;
          } else {
            if (countryCodes.filter(v => v.region === country.region).length === 0) {
              country.region = null;
            }
          }
        }
      });
    },
    getRegions(country) {
      let regions = [];
      for (let countryItem of this.countryCodes.filter(item => item.symbol === country.country_code)) {
        regions.push(countryItem.region);
      }
      if (!regions.includes(country.region)) {
        country.region = regions[0];
      }
      return regions;
    },
    expandedAccommodation(country, isOpen) {
      if (typeof isOpen === "undefined") {
        if (country.accommodation.length === 0) {
          // add new accommodation on panel expand
          this.addAccommodation(country);
        }
      } else {
        // clean empty accommodations
        for (let index in country.accommodation) {
          let accommodation = country.accommodation[index];
          if (
            accommodation.id === null &&
            (accommodation.amount == null || accommodation.amount.length < 1) &&
            accommodation.settlement_type_id == null &&
            accommodation.booking_id == null &&
            (accommodation.currency == null || accommodation.currency.length < 1 || accommodation.currency === "PLN") &&
            (accommodation.end_date == null || accommodation.end_date.length < 1) &&
            (accommodation.start_date == null || accommodation.start_date.length < 1) &&
            (accommodation.file_id == null || accommodation.file_id.length < 1)
          ) {
            this.removeAccommodation(country, accommodation);
          }
        }
      }
    },
    addFileToDelegationFiles(item) {
      const newItem = item;
      newItem.description = this.$t("delegation.form.fileAttachmentDescription.accommodation");
      newItem.category = "accommodation";
      this.$store.dispatch("Delegation/addFile", newItem);
    },
    removeFileFromDelegationFiles(item) {
      this.$store.dispatch("Delegation/removeFile", item.id);
    },
    importAccommodationData(bookingData, accommodation) {
      accommodation.start_date = bookingData.hotelAttributes.start_date;
      accommodation.end_date = bookingData.hotelAttributes.end_date;
      //TODO IMPORT SNIADAŃ OBIADÓW I KOLACJI
    },

    startDateDefaultValueCountry(countryItem) {
      let indexOfItem = this.delegation.country.indexOf(countryItem);
      if (indexOfItem === 0) {
        return this.delegation.start_date;
      }
      return this.delegation.country[indexOfItem - 1].out_date;
    },
    endDateDefaultValueCountry(countryItem) {
      let indexOfItem = this.delegation.country.indexOf(countryItem);
      if (indexOfItem === this.delegation.country.length - 1) {
        return this.delegation.end_date;
      }
      return this.delegation.country[indexOfItem + 1].in_date;
    },
    startDateDefaultValueAccommodation(countryIndex, accommodationIndex) {
      if (accommodationIndex === 0) {
        return this.delegation.country[countryIndex].in_date.substring(0, 10);
      }
      return this.delegation.country[countryIndex].accommodation[accommodationIndex - 1].end_date;
    },
    endDateDefaultValueAccommodation(countryIndex, accommodationIndex) {
      if (accommodationIndex === this.delegation.country[countryIndex].accommodation.length - 1) {
        return this.delegation.country[countryIndex].out_date.substring(0, 10);
      }
      return this.delegation.country[countryIndex].accommodation[accommodationIndex + 1].start_date;
    }
  },
  created() {
    this.getCountry(this.delegation.user_id);
  }
};
</script>

<style>
.v-input input {
  width: 1%;
}
</style>
